module.exports = __webpack_public_path__ + "static/media/request-transfer-miles-united.6cc203b7.png";